import { get } from "lodash";
import React from "react";
import { ChipField, EditButton, List as RaList, TextField } from "react-admin";
import ResponsiveList from "../components/lists/ResponsiveList";
import { useListStyles } from "../components/lists/useStyles";
import perPage from "../utils/per-page";
import Actions from "./Actions";
import Filters from "./Filters";

const Datagrid = (props) => {
	const hasBookmakerFilter = !!get(props, "filterValues.bookmaker_id");
	return (
		<ResponsiveList
			{...props}
			mobileHeader={
				<React.Fragment>
					<TextField
						source="user.username"
						variant="subtitle1"
						style={{ fontWeight: "bold" }}
					/>
					<EditButton size="small" />
				</React.Fragment>
			}
			mobileBody={
				<React.Fragment>
					{!hasBookmakerFilter && (
						<TextField source="bookmaker.name" style={{ fontWeight: "bold" }} />
					)}
					<TextField source="user.profile.name" />
					<TextField source="user.profile.surname" />
				</React.Fragment>
			}
		>
			<TextField source="id" label="ID" style={{ fontWeight: "bold" }} />
			{!hasBookmakerFilter && (
				<ChipField style={{ marginLeft: 0 }} source="bookmaker.name" />
			)}
			<TextField
				source="user.name"
				label="resources.bookmaker-lists.fields.user_id"
				style={{ fontWeight: "bold" }}
			/>
			<TextField source="user.username" />
		</ResponsiveList>
	);
};

const List = (props) => {
	const classes = useListStyles();
	return (
		<RaList
			{...props}
			classes={classes}
			actions={<Actions />}
			filters={<Filters />}
			perPage={perPage()}
			sort={{ field: "id", order: "DESC" }}
		>
			<Datagrid {...props} />
		</RaList>
	);
};
export default List;
